module.exports = __webpack_public_path__ + "img/search-input.ddcc049c.svg";